<template>
    <!-- Ekran-bazlı eşik: tanımlı (ham) aksiyon sayısı >= threshold ise ⋮ dropdown,
         değilse satır-içi sade ikon butonlar. Karar ham actions.length'e göre verilir
         (koşullu/show:false olanlar dahil) → aynı tablodaki tüm satırlar tutarlı. -->
    <b-dropdown v-if="useDropdown" variant="link" no-caret right boundary="window" toggle-class="wh-actions-toggle" size="sm" :aria-label="ariaLabel">
        <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="18" style="color:#6B7280;" />
        </template>
        <b-dropdown-item v-for="(a, i) in visibleActions" :key="i" @click="a.handler && a.handler()">
            <feather-icon v-if="a.icon" :icon="a.icon" class="mr-50" :style="{ color: a.color || '#6B7280' }" />
            <span :style="a.color ? { color: a.color } : {}">{{ a.label }}</span>
        </b-dropdown-item>
    </b-dropdown>
    <span v-else class="wh-inline-actions d-inline-flex align-items-center">
        <b-button
            v-for="(a, i) in visibleActions"
            :key="i"
            variant="link"
            class="p-0 wh-inline-action"
            :aria-label="a.label"
            v-b-tooltip.hover="a.label"
            @click="a.handler && a.handler()"
        >
            <feather-icon v-if="a.icon" :icon="a.icon" size="18" :style="{ color: a.color || '#6B7280' }" />
        </b-button>
    </span>
</template>

<script>
export default {
    name: 'ListActionsDropdown',
    props: {
        actions: {
            type: Array,
            default: function () { return [] }
        },
        ariaLabel: {
            type: String,
            default: 'İşlemler'
        },
        // Ekran-bazlı eşik: tanımlı aksiyon sayısı bu değere ulaşırsa dropdown kullanılır.
        threshold: {
            type: Number,
            default: 3
        }
    },
    computed: {
        // O satırda gösterilecek aksiyonlar (show:false gizli). Hem dropdown hem inline kullanır.
        visibleActions: function () {
            return this.actions.filter(function (a) { return a && a.show !== false })
        },
        // Dropdown/inline KARARI: tanımlı (null olmayan) ham aksiyon sayısına göre — ekran-bazlı.
        useDropdown: function () {
            return this.actions.filter(function (a) { return a }).length >= this.threshold
        }
    }
}
</script>

<style>
.wh-inline-action + .wh-inline-action {
    margin-left: 0.5rem;
}
.wh-inline-action {
    line-height: 1;
}
</style>
